import styled, { css } from 'styled-components';
import { Button } from '../../../../button';
import { IconContainer } from '../../../../icon';
import { stylePropertiesToCss } from '../../../../../design-tokens/style-mixins';
import { pxToRem, weightToNumber } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
const TOGGLE_ICON_SIZE = 20;
export const navigationToggleContainerStyles = ({ theme, $isActive, $navigationIsOpen, $loginMenuIsOpen, }) => css `
	position: relative;
	color: ${$isActive ? theme.colors.highlight.iconInteractive : theme.colors.medium.iconInactive};
	grid-area: ${NAVIGATION_GRID_AREAS.TOGGLE};
	padding: ${pxToRem(theme.spacing['200'])};
	margin: 0;
	${$loginMenuIsOpen && `margin-right: ${pxToRem(7)};`}
	cursor: pointer;
	border: none;
	gap: 0;
	${stylePropertiesToCss(theme.typography.paragraphs['75BodyTextXs'])};
	font-weight: 600;
	font-size: 0;

	&:hover,
	&:focus {
		background: none;
		border: none;
	}

	&:hover {
		color: ${theme.colors.base.iconHover};
	}

	&:focus,
	&:active {
		color: ${theme.colors.action.iconActive};
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.sm)}) {
		gap: ${$navigationIsOpen ? 0 : pxToRem(theme.spacing['50'])};
		font-size: unset;

		${$navigationIsOpen &&
    css `
			font-size: 0;
		`}
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		display: none;
	}

	${IconContainer} {
		width: ${pxToRem(TOGGLE_ICON_SIZE)};
		height: ${pxToRem(TOGGLE_ICON_SIZE)};

		${$navigationIsOpen &&
    css `
			&:hover {
				color: ${theme.colors.highlight.iconHover};
			}
		`}
	}
`;
export const NavigationToggleContainer = styled(Button) `
	${navigationToggleContainerStyles}
`;
